import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class BlogPage extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/blog/page'
    super(store, path)
  }
}
